// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pane_aNVmS {
  padding : 40px;
  position: relative;
}

.blocker_YWUq5 {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  background-color: var(--color-base050);
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/login/temporaryUser/TemporaryUserLoginScreen.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;AACd","sourcesContent":[".pane {\n  padding : 40px;\n  position: relative;\n}\n\n.blocker {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  background-color: var(--color-base050);\n  opacity: 0.8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pane": `pane_aNVmS`,
	"blocker": `blocker_YWUq5`
};
export default ___CSS_LOADER_EXPORT___;
